export const familiarityOptions = [
  {
    label: '直接认识',
    value: 0
  },
  {
    label: '能帮忙找到',
    value: 1
  },
  {
    label: '接收任务',
    value: 2
  }
];